export const BRAND_NAME = 'IZZY Corporation';
export const BRAND_SUBTITLE = 'Sistema de Seguimiento';
export const BRAND_FOOTER = `${BRAND_NAME} — ${BRAND_SUBTITLE}`;
export const LOGO_URL =
  'https://static.readdy.ai/image/5e0dc67cda370742b3d5bcd513fed04e/7ccb60a178e69ccb6f070627bdcb7304.jpeg';